/**
 * Zeitangaben einer Meldung, wie die Liste und das Detail sie zeigen.
 *
 * Kurz in der Zeile („11:42", „gestern", „Mi", „04.09."), ausführlich beim
 * Überfahren und im Detail. Was „heute" ist, entscheidet die Uhr des Browsers.
 */

const uhr = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' })
const wochentag = new Intl.DateTimeFormat('de-DE', { weekday: 'short' })
const tagKurz = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit' })
const tagLang = new Intl.DateTimeFormat('de-DE', {
  weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
})
const uhrUtc = new Intl.DateTimeFormat('de-DE', {
  hour: '2-digit', minute: '2-digit', timeZone: 'UTC',
})

function tagesanfang(datum: Date): number {
  return new Date(datum.getFullYear(), datum.getMonth(), datum.getDate()).getTime()
}

/** Heute die Uhrzeit, gestern „gestern", diese Woche der Wochentag, sonst der Tag. */
export function zeitKurz(iso: string, jetzt: Date = new Date()): string {
  const datum = new Date(iso)
  const tage = Math.round((tagesanfang(jetzt) - tagesanfang(datum)) / 86_400_000)
  if (tage <= 0) return uhr.format(datum)
  if (tage === 1) return 'gestern'
  if (tage < 7) return wochentag.format(datum).replace('.', '')
  return tagKurz.format(datum)
}

/** „Freitag, 6. September 2026" */
export function zeitTag(iso: string): string {
  return tagLang.format(new Date(iso))
}

/** „11:42 · UTC 09:42" — die Weltzeit dazu, weil Quellen sie oft so nennen. */
export function zeitUhr(iso: string): string {
  const datum = new Date(iso)
  return `${uhr.format(datum)} · UTC ${uhrUtc.format(datum)}`
}

/** „Freitag, 6. September 2026, 11:42" */
export function zeitVoll(iso: string): string {
  const datum = new Date(iso)
  return `${tagLang.format(datum)}, ${uhr.format(datum)}`
}

export function nurUhr(iso: string): string {
  return uhr.format(new Date(iso))
}
